<template>
	<!-- Footer start -->
	<div class="bg-stone-900 w-full flex justify-center items-center md:justify-evenly flex-col md:flex-row gap-8 p-8">
		<!-- Overview start -->
		<!-- Logo and Text start -->
		<div class="h-full flex items-end">
			<img src="@/assets/images/logo/mme_logo_only.webp" alt="Mozgásban Maradók Egyesülete"
				class="h-16 w-auto max-w-full mr-4 invert" />
			<span class="text-lg font-bold leading-tight uppercase relative text-stone-100" style="top: 5px; right: 5px">
				Mobil<br />Mászófal
			</span>
		</div>
		<!-- Logo and Text end -->
		<!-- Overview end -->

		<!-- Links start -->
		<div class="text-stone-100 flex justify-center items-center gap-8">
			<a href="https://instagram.com/mozgasbanmaradok" target="_blank" class="hover:text-white"
				aria-label="Instagram - Mozgásban Maradók Egyesülete">
				<i class="fa-brands fa-instagram socialIcon hover:text-white text-2xl" aria-hidden="true"></i>
			</a>
			<a href="https://www.facebook.com/mozgasbanmaradok" target="_blank" class="hover:text-white"
				aria-label="Facebook - Mozgásban Maradók Egyesülete">
				<i class="fa-brands fa-facebook socialIcon hover:text-white text-2xl" aria-hidden="true"></i>
			</a>
		</div>
		<!-- Links end -->
	</div>
	<!-- Footer end -->
</template>

<script>
export default {

}
</script>

<style></style>